import React from "react";

import {

    ResponsiveContainer,

    BarChart,

    Bar,

    XAxis,

    YAxis,

    Tooltip,

    CartesianGrid,

} from "recharts";

import "../../styles/OrdersChart.css";

const OrdersChart = ({ data = [] }) => {

    return (

        <div className="chart-card">

            <h3>Orders Analytics</h3>

            <ResponsiveContainer
                width="100%"
                height={320}
            >

                <BarChart data={data}>

                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis dataKey="name" />

                    <YAxis />

                    <Tooltip />

                    <Bar
                        dataKey="orders"
                        fill="#d62828"
                    />

                </BarChart>

            </ResponsiveContainer>

        </div>

    );

};

export default OrdersChart;